export default function StatusBadge({ item, ctx, statusCounts, active }) {
  if (item.hideBadgeForRoles?.includes(ctx.role)) return null;

  const count = statusCounts.find((entry) => entry.status === item.badgeStatusKey)?.count || 0;

  return (
    <span className={`sidebar-badge${active ? ' sidebar-badge--active' : ''}`}>
      {count}
    </span>
  );
}
